import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NavController,
  NavParams,
  ModalController,
  IonicModule,
} from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { PessoaProvider } from 'src/app/services/pessoa/pessoa';
@Component({
  selector: 'app-pessoa-migrar-modal',
  templateUrl: './pessoa-migrar-modal.page.html',
  styleUrls: ['./pessoa-migrar-modal.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SemRegistroComponent,
    TranslateModule,
    NomenclaturaPipe,
  ],
})
export class PessoaMigrarModalPage implements OnInit {
  dataSelect: any = [];
  nomeModal: string = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public pessoaProvider: PessoaProvider,
    public modalCtrl: ModalController
  ) {
    this.dataSelect = this.navParams.get('dataSelect');
    this.nomeModal = this.navParams.get('nomeModal');
    this.dataSelect.forEach(
      (element: { selected: boolean, disable: boolean }) => {
        element.selected = element.disable ? false : true;
      }
    );
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss(this.dataSelect);
  }

  selectData() {
    this.modalCtrl.dismiss(this.dataSelect);
  }
}
